var indexOf = [].indexOf;

angular.module('gym.bulkImports').controller('BulkImportsListCtrl', ["$scope", "$state", "$window", "loadingAnimation", "ngTableParams", "EmploymentService", "BulkImports", function($scope, $state, $window, loadingAnimation, ngTableParams, EmploymentService, BulkImports) {
  $scope.permissions = EmploymentService.get().permissions;
  if (!$scope.permissions.perform_bulk_imports) {
    $state.go('gym.dashboard');
  }
  $scope.tableParams = new ngTableParams({
    page: 1,
    count: 10
  }, {
    counts: [],
    total: 0,
    getData: function($defer, $params) {
      loadingAnimation.show();
      return BulkImports.all('bulk_imports').getList($params.url()).then(function(data) {
        $params.total(data.meta.total);
        $defer.resolve(data);
        return loadingAnimation.hide();
      });
    }
  });
  $scope.download = function(bulkImport) {
    var url;
    url = bulkImport.all('download').getRestangularUrl();
    $window.open(url, '_blank');
    return true;
  };
  $scope.deleteAvailable = function(bulkImport) {
    var ref, statuses;
    statuses = ['file_processing', 'importing', 'import_complete'];
    return ref = bulkImport.status, indexOf.call(statuses, ref) < 0;
  };
  return $scope.delete = function(bulkImport) {
    if ($window.confirm('This will permanently remove the selected import. Are you sure?')) {
      return bulkImport.remove().then(function() {
        return $scope.tableParams.reload();
      });
    }
  };
}]);
